import { render, staticRenderFns } from "./bedTable.vue?vue&type=template&id=5e209f71&scoped=true"
import script from "./bedTable.vue?vue&type=script&lang=js"
export * from "./bedTable.vue?vue&type=script&lang=js"
import style0 from "./bedTable.vue?vue&type=style&index=0&id=5e209f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e209f71",
  null
  
)

export default component.exports